query GetCspBrand($id: ID!) {
  cspBrand(id: $id) {
        id
        insertedAt
        updatedAt

        active

        origin_id

    
        entityType
        tcr_csp_id
        tcr_brand_id
      
        firstName
        lastName
        displayName
        companyName
        ein
        einIssuingCountry
        phoneNumber
        mobilePhoneNumber
        street
        city
        state
        postalCode
        country
        email
        stockSymbol
        stockExchange

        ipAddress

        website
        brandRelationship
        vertical
        altBusinessId
        altBusinessIdType

        universalEin
        referenceId
        optionalAttributes
        isMock

        identityStatus
        registrationScore

        account {
          id
          name
        }
      
  }
}
